import React, { Component } from "react";
import { ProjectListHeader } from "../../../components";
import { Link } from "react-router-dom";

class IndicatorGenerator extends Component {
  getParams = () => {
    return this.props.match.params || {};
  };
  render() {
    const params = this.getParams();

    return (
      <React.Fragment>
        <span>This feature is only available on the App version of MASAR.</span>
      </React.Fragment>
    );
  }
}

export default IndicatorGenerator;



// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/IndicatorGeneratorFormularies.js